import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import COLORS from '../../../theme/colors';
import Card from '../../generic/Card/Card';

const LoadingBreakdown: VoidFunctionComponent = () => {
  return (
    <Card variant="fill" isFullWidth>
      <Card.Content>
        <ContentLoader width="100%" height="300px" foregroundColor={COLORS.fossaGray05} backgroundColor={COLORS.fossaGray10}>
          <rect x="0" y="0" rx="3" ry="3" width="250" height="34px" />
          <rect x="0" y="56" rx="3" ry="3" width="100%" height="180px" />
          <rect x="0" y="280" rx="3" ry="3" width="160" height="24px" />
        </ContentLoader>
      </Card.Content>
    </Card>
  );
};

export default LoadingBreakdown;
